const getTokenFromCapacitor = () => {
  if (typeof window === 'undefined') return undefined

  const urlParams = new URLSearchParams(window.location.search)

  return urlParams.get('tokenFromCapacitor')
}

export const tokenFromCapacitor = getTokenFromCapacitor()
